import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hero-capacitate',
  templateUrl: './hero-capacitate.component.html',
  styleUrls: ['./hero-capacitate.component.scss']
})
export class HeroCapacitateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
